import React, { useState } from "react";
import Phone_icon from "../../assets/images/svg/call_icon.svg";
import user_icon from "../../assets/images/svg/user_icon.svg";
import eamil_icon from "../../assets/images/svg/email_icon.svg";
import edit_icon from "../../assets/images/svg/edit_icon.svg";
import "../../styles/contactUs.css";


function getFieldError(name, value, checkRequired) {
  if (!value) {
    return checkRequired ? "This field is required" : "";
  }

  if (name === "name" && !/^[A-Za-z\s]{2,50}$/.test(value)) {
    return "Enter a valid name (letters only)";
  }
  if (name === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
    return "Enter a valid email address";
  }
  if (name === "phone" && !/^\d{10}$/.test(value)) {
    return "Enter a valid 10-digit number";
  }
  if (name === "message" && value.trim().split(/\s+/).length > 150) {
    return "Keep it under 150 words";
  }

  return "";
}

const BASE_SUBJECTS = ["Feedback", "Support", "Business Development"];

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    vertical: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [subjectOptions, setSubjectOptions] = useState(BASE_SUBJECTS);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const cleaned =
      name === "phone" ? value.replace(/\D/g, "").slice(0, 10) : value;

    setFormData((prev) => ({ ...prev, [name]: cleaned }));
    setErrors((prev) => ({
      ...prev,
      [name]: getFieldError(name, cleaned, false),
    }));

    if (name === "vertical") {
      const options =
        value === "Skilling" ? [...BASE_SUBJECTS, "Admission"] : BASE_SUBJECTS;
      setSubjectOptions(options);
      setFormData((prev) =>
        options.includes(prev.subject) ? prev : { ...prev, subject: "" },
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {
      name: getFieldError("name", formData.name, true),
      email: getFieldError("email", formData.email, true),
      phone: getFieldError("phone", formData.phone, true),
      vertical: getFieldError("vertical", formData.vertical, true),
      subject: getFieldError("subject", formData.subject, true),
      message: getFieldError("message", formData.message, true),
    };
    setErrors(newErrors);

    const hasError = Object.values(newErrors).some((msg) => msg);
    if (hasError) {
      setSuccessMessage("");
      setErrorMessage("Please fix the highlighted fields.");
      return;
    }

    // const googleFormURL =
    //   "https://docs.google.com/forms/d/e/1FAIpQLSeQkAk_jf5_G9SYhNzmOxRTh8tem0iSss6ekONnhtKehIO4dw/formResponse";

   const googleFormURL = "https://docs.google.com/forms/d/e/1FAIpQLSc7KJfphK0EJob3ixEXXIsUgmuCfA5zB2WNXnxEQigDeAB_aQ/formResponse";
    const googleFormData = new FormData();
    // googleFormData.append("entry.1589415443", formData.name);
    // googleFormData.append("entry.1589453631", formData.email);
    // googleFormData.append("entry.1178363187", formData.phone);
    // googleFormData.append("entry.316787658", formData.vertical);
    // googleFormData.append("entry.1769960232", formData.subject);
    // googleFormData.append("entry.1214330793", formData.message);
    googleFormData.append("entry.1111160867", formData.name);
googleFormData.append("entry.658001450", formData.email);
googleFormData.append("entry.2076422493", formData.phone);
googleFormData.append("entry.517091391", formData.vertical);
googleFormData.append("entry.831575009", formData.subject);
googleFormData.append("entry.517498258", formData.message);
    setSubmitting(true);
    
    fetch(googleFormURL, {
      method: "POST",
      mode: "no-cors",
      body: googleFormData,
    })
      .then(() => {
        setSuccessMessage("Message sent successfully!");
        setErrorMessage("");
        setFormData({
          name: "",
          email: "",
          subject: "",
          phone: "",
          vertical: "",
          message: "",
        });
        setErrors({});
        setSubjectOptions(BASE_SUBJECTS);
      })
      .catch(() => {
        setErrorMessage("Failed to send message. Please try again.");
        setSuccessMessage("");
      })
      .finally(() => setSubmitting(false));
  };

  const fieldClass = (name) =>
    errors[name] ? "cu-field cu-field--invalid" : "cu-field";

  return (
    <section className="cu cu-form-section">
      <div className="container">
        <div className="row g-4 g-lg-5">
          <div className="col-lg-4" data-aos="fade-right">
            <div className="cu-info-card">
              <h3>Let&rsquo;s Talk</h3>
              <p>
                Have questions, feedback, or need assistance? Our team is just a
                message away!
              </p>

              <a
                className="cu-info-row"
                href="https://maps.google.com/?q=Plot no. 251, Phase 4, Udyog Vihar, Sector 18, Gurugram, Haryana 122015"
                target="_blank"
                rel="noreferrer"
              >
                <span className="cu-info-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </span>
                <span className="cu-info-text">
                  <span className="cu-info-label">Visit us</span>
                  Plot no. 251, Phase 4, Udyog Vihar, Sector 18, Gurugram, Haryana
                  122015
                </span>
              </a>

              <a className="cu-info-row" href="mailto:support@hkimedia.com">
                <span className="cu-info-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="5" width="18" height="14" rx="2" />
                    <path d="m4 7 8 6 8-6" />
                  </svg>
                </span>
                <span className="cu-info-text">
                  <span className="cu-info-label">Email us</span>
                  Support@hkimedia.com
                </span>
              </a>

              <p className="cu-info-note">
                We usually reply within one business day.
              </p>
            </div>
          </div>

          <div className="col-lg-8" data-aos="fade-left">
            <form onSubmit={handleSubmit} className="cu-form">
              <div className="row g-3">
                <div className="col-md-6">
                  <div className={fieldClass("name")}>
                    <img src={user_icon} alt="" aria-hidden="true" />
                    <input
                      placeholder="Name"
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.name && (
                    <span className="cu-field-error">{errors.name}</span>
                  )}
                </div>

                <div className="col-md-6">
                  <div className={fieldClass("email")}>
                    <img src={eamil_icon} alt="" aria-hidden="true" />
                    <input
                      placeholder="Email Address"
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.email && (
                    <span className="cu-field-error">{errors.email}</span>
                  )}
                </div>

                <div className="col-md-6">
                  <div className={fieldClass("phone")}>
                    <img src={Phone_icon} alt="" aria-hidden="true" />
                    <input
                      placeholder="Mobile Number"
                      type="tel"
                      inputMode="numeric"
                      maxLength={10}
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.phone && (
                    <span className="cu-field-error">{errors.phone}</span>
                  )}
                </div>

                <div className="col-md-6">
                  <div className={fieldClass("vertical")}>
                    <select
                      name="vertical"
                      value={formData.vertical}
                      onChange={handleChange}
                    >
                      <option disabled value="">
                        Vertical
                      </option>
                      <option value="Skilling">Skilling</option>
                      <option value="Entertainment">Entertainment</option>
                      <option value="Advertisement">Advertisement</option>
                      <option value="Event">Event</option>
                      <option value="AR/VR">AR/VR</option>
                    </select>
                  </div>
                  {errors.vertical && (
                    <span className="cu-field-error">{errors.vertical}</span>
                  )}
                </div>

                <div className="col-12">
                  <div className={fieldClass("subject")}>
                    <select
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                    >
                      <option disabled value="">
                        Subject
                      </option>
                      {subjectOptions.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                  {errors.subject && (
                    <span className="cu-field-error">{errors.subject}</span>
                  )}
                </div>

                <div className="col-12">
                  <div className={fieldClass("message")}>
                    <img src={edit_icon} alt="" aria-hidden="true" />
                    <textarea
                      rows={6}
                      placeholder="How can we help you? Feel free to get in touch!"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.message && (
                    <span className="cu-field-error">{errors.message}</span>
                  )}
                </div>

                {(successMessage || errorMessage) && (
                  <div className="col-12">
                    {successMessage && (
                      <p className="cu-alert cu-alert--success">
                        {successMessage}
                      </p>
                    )}
                    {errorMessage && (
                      <p className="cu-alert cu-alert--error">{errorMessage}</p>
                    )}
                  </div>
                )}

                <div className="col-12">
                  <button
                    className="cu-btn cu-btn--primary"
                    type="submit"
                    disabled={submitting}
                  >
                    {submitting ? "Sending…" : "Send Message"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
